<template>
  <div>
    <a-form :form="form" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Postcode">
            <a-input placeholder="Postcode"
                     v-model="property.postal_code"/>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="Huisnummer">
            <a-input placeholder="Huisnummer"
                     type="number"
                     v-model="property.number"
                     v-on:keypress="isNumber($event)"/>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="Letter">
            <a-input placeholder="Letter"
                     v-model="property.number_letter"
                     v-on:keypress="isLetter($event)"/>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="Toevoeging">
            <a-input placeholder="Toevoeging"
                     v-model="property.number_addition"
                     v-on:keypress="isNumberOrLetter($event)"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Straat">
            <a-input
                v-model="property.street"
                placeholder="Straat"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Stad">
            <a-input
                v-model="property.city"
                placeholder="Stad"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Land">
            <a-select
                v-model="property.country_id"
                v-on:change="onCountryChange"
                placeholder="Selecteer een land"
            >
              <a-select-option v-for="country in countries" :key="country.id" :value="country.id">
                {{ country.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-button v-on:click="onCancelCustomProperty">Annuleren</a-button>
          <a-button type="primary" v-on:click="onSubmitCustomProperty">Opslaan</a-button>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import countriesApi from '~/api/country';
import propertyApi from '~/api/property';

const moment = require('moment');

export default {
  name: "PropertyManualCreateComponent",
  components: {},
  props: {
    postalCode: {
      type: String,
      required: false,
      default: null,
    },
    houseNumber: {
      type: String,
      required: false,
      default: null
    },
    houseNumberAddition: {
      type: String,
      required: false,
      default: null
    },
    houseNumberLetter: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {
      postalCodeValue: this.postalCode,
      houseNumberValue: this.houseNumber,
      houseNumberLetterValue: this.houseNumberLetter,
      houseNumberAdditionValue: this.houseNumberAddition,
      countries: [],
      form: this.$form.createForm(this),
      property: {
        postal_code: this.postalCode,
        number: this.houseNumber,
        number_letter: this.houseNumberLetter,
        number_addition: this.houseNumberAddition,
      },
    };
  },
  computed: {},
  mounted() {
    countriesApi.all().then(response => {
      this.countries = response.data;
    })
  },
  methods: {
    onCancelCustomProperty() {
      this.$emit('cancel');
    },
    onSubmitCustomProperty() {
      propertyApi.create(this.property).then(response => {
        propertyApi.find(response.data.id).then(response => {
          this.$emit('created', response.data);
        });
      }).catch(error => {

      });
    },
    onCountryChange() {
      this.$set(this.property, 'country', {
        data: this.countries.find(country => country.id === this.property.country_id)
      });
    }
  },
};
</script>
<style scoped>
.drawer-title {
  margin-bottom: 30px;
}

.pull-right {
  float: right;
}
</style>